export const containerId = 'root';
export const modalId = 'modal';
export const portalTakeOverId = 'takeover-portal';
export const portalVideoCallId = 'videocall-portal';
export const portalVideoCallTopNotificationId = 'notification-top-portal';
export const portalVideoCallTopNotificationMainId =
  'notification-top-portal-main';
export const portalNotificationId = 'notification-portal';
